// extracted by mini-css-extract-plugin
module.exports = {"google-login":"google-login--2JioO","googleLogin":"google-login--2JioO"};